import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import PremiumSection from "../../home/components/PremiumSection";
import { useBlogDetail } from "../hooks/useBlogDetail";
import { normalizeLanguage } from "../../../utils/language";
import { buildImageUrl } from "../../../services/apiClient";

const BlogSkeleton = () => {
  const { t } = useTranslation();
  return (
    <div className="min-h-screen bg-gradient-to-b from-blog to-customPurple-premium">
      <div className="w-[90%] md:w-[90%] mx-auto pt-44 animate-pulse">
        <div className="h-12 bg-gray-700/50 rounded-lg w-3/4 mx-auto mb-8" />
        <div className="h-[50vh] bg-gray-700/50 rounded-lg mb-8" />
        <div className="space-y-4 mb-20">
          <div className="h-4 bg-gray-700/50 rounded w-full" />
          <div className="h-4 bg-gray-700/50 rounded w-5/6" />
          <div className="h-4 bg-gray-700/50 rounded w-4/6" />
          <div className="h-4 bg-gray-700/50 rounded w-5/6" />
          <div className="h-4 bg-gray-700/50 rounded w-3/4" />
          <div className="h-4 bg-gray-700/50 rounded w-4/6" />
        </div>
        <div className="mt-20 bg-gradient-to-b from-customPurple-premium to-blog">
          <div className="h-[300px] bg-gray-700/10 rounded-lg" />
        </div>
        <div className="text-center text-white">{t("blogDetail.loading")}</div>
      </div>
    </div>
  );
};

function BlogDetailPage() {
  const { t, i18n } = useTranslation();
  const { slug = "" } = useParams();
  const language = normalizeLanguage(i18n.language);

  const { data, isError, error, isLoading } = useBlogDetail(slug, language);

  if (isLoading) {
    return <BlogSkeleton />;
  }

  if (isError) {
    const message =
      (error as Error)?.message === "BLOG_NOT_FOUND"
        ? t("blogDetail.notFound")
        : t("blogDetail.error");
    return (
      <div className="min-h-screen bg-gradient-to-b from-blog to-customPurple-premium flex justify-center items-center text-white">
        <p>{message}</p>
      </div>
    );
  }

  if (!data) {
    return (
      <div className="min-h-screen bg-[#0F1117] flex justify-center items-center text-white">
        {t("blogDetail.notFound")}
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-b from-blog to-customPurple-premium">
      <div className="detail-container w-[100%] md:w-[90%] mx-auto">
        <div className="blog-detail pt-44 text-white p-10">
          <h1 className="text-white text-4xl sm:text-5xl text-center mb-8">
            {data.baslik}
          </h1>
          <div className="relative mb-10">
            <img
              src={buildImageUrl(data.img_url)}
              className="mx-auto max-h-[80vh] object-contain"
              alt={data.baslik}
              loading="lazy"
            />
          </div>
          <div
            className="blog-content prose prose-invert max-w-none"
            dangerouslySetInnerHTML={{ __html: data.aciklama }}
          />
          <style>{`
            .blog-content img {
              max-width: 50% !important;
              max-height: 50vh !important;
              margin: 0 auto !important;
              display: block;
            }
          `}</style>
        </div>
      </div>
      <PremiumSection className="bg-gradient-to-b from-transparent to-blog mt-20" />
    </div>
  );
}

export default BlogDetailPage;
